import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FramingBand } from '../components/FramingBand';
import { ProblemSection } from '../components/ProblemSection';
import { PlatformOverview } from '../components/PlatformOverview';
import { OperatingModel } from '../components/OperatingModel';
import { CapabilityDomains } from '../components/CapabilityDomains';
import { HumanOpportunity } from '../components/HumanOpportunity';
import { LifecycleArchitecture } from '../components/LifecycleArchitecture';
import { Solutions } from '../components/Solutions';
import { ProductEcosystem } from '../components/ProductEcosystem';
import { GlobalArchitecture } from '../components/GlobalArchitecture';
import { LeadershipReadiness } from '../components/LeadershipReadiness';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { RelatedInitiative } from '../components/initiatives/RelatedInitiative';
import { HumanCapabilityModels } from '../components/HumanCapabilityModels';
export function HumanCapabilityPage() {
  return <>
      <HeroSection data-id="element-1875" data-mp="3k524pl9s6tzs" />
      <FramingBand data-id="element-1876" data-mp="3k4ai2zy5w6ln" />
      <HumanCapabilityModels data-id="element-1877" data-mp="3k5vc8ogkdniz" />
      <ProblemSection data-id="element-1878" data-mp="3k2zfh3ggd4w4" />
      <PlatformOverview data-id="element-1879" data-mp="3p4f04uepx9dz" />
      <OperatingModel data-id="element-1880" data-mp="3p3ws70ip16q8" />
      <CapabilityDomains data-id="element-1881" data-mp="3p2lsbbsdcj4e" />
      <HumanOpportunity data-id="element-1882" data-mp="3p2bzzhjupzvj" />
      <LifecycleArchitecture data-id="element-1883" data-mp="3tuloct5birvp" />
      <Solutions data-id="element-1884" data-mp="3tvwxz9lg2tuq" />
      <ProductEcosystem data-id="element-1885" data-mp="3twgaubw8ms1w" />
      <RelatedInitiative name="Cognocracy" status="Concept Proposal" body="Explore a proposed civic application of the Human Capability Framework and NCJI." href="/projects/cognocracy" data-id="element-1886" data-mp="3twq202t0r596" />
      <GlobalArchitecture data-id="element-1887" data-mp="boqt4d4ixace" />
      <LeadershipReadiness data-id="element-1888" data-mp="bqk0jumynylg" />
      <FAQ data-id="element-1889" data-mp="bn5xsladxndh" />
      <FinalCTA data-id="element-1890" data-mp="bnfq4fiwk6mc" />
    </>;
}